module.exports = __webpack_public_path__ + "img/35.5d64be63.jpg";